import Api, {getCancelToken, validToken} from 'services';

// ACTION TYPES
export const filesHasErrored = () => ({type: '[FILES] HAS_ERRORED'});
export const filesIsLoading = () => ({type: '[FILES] IS_LOADING'});
export const filesFetchSuccess = data => ({type: '[FILES] FETCH_SUCCESS', data});
export const filesFetchSuccessCount = data => ({type: '[FILES] FETCH_SUCCESS_COUNT', data});
export const filesCountFails = countFails => ({type: '[FILES] COUNT_FAILS', countFails});
export const filesCountRepository = countRepository => ({type: '[FILES] COUNT_REPOSITORY', countRepository});
export const filesUploadingUpdateFiles = uploadingFiles => ({
    type: '[FILES] FILES_UPLOADING_UPDATE_FILES',
    uploadingFiles
});
export const filesUploadingUpdateFile = file => ({type: '[FILES] FILES_UPLOADING_UPDATE_FILE', file});
export const filesUploadingRemoveFile = file => ({type: '[FILES] FILES_UPLOADING_REMOVE_FILE', file});
export const filesUploadedSuccess = file => ({type: '[FILES] FILES_UPLOADED_SUCCESS', file});
export const filesUploadedSuccessHideMessage = file => ({type: '[FILES] FILES_UPLOADED_SUCCESS_HIDE_MESSAGE', file});

// ACTION CREATORS
export const files_action_fetch = (params = {}) => dispatch => {

    dispatch(filesIsLoading());
    Api.Files.getFiles(params)
        .then(data => dispatch(filesFetchSuccess(data)))
        .catch(() => dispatch(filesHasErrored()));
};

export const files_action_delete = (ids, reFetchParams) => dispatch => {

    dispatch(filesIsLoading());
    Api.Files.deleteFiles(ids)
        .then(() => dispatch(files_action_fetch(reFetchParams)))
        .catch(() => dispatch(filesHasErrored()));
};

export const files_action_download = (originalFile, originalName, bucket) => () => {

    Api.Files.downloadFiles(originalFile, originalName, bucket);
};

export const files_action_count = () => dispatch => {
    dispatch(filesIsLoading());
    Api.Files.getFilesCount()
        .then(data => dispatch(filesFetchSuccessCount(data)))
        .catch(() => dispatch(filesHasErrored()));
};

export const files_action_start_upload_files = files => dispatch => {

    dispatch(filesUploadingUpdateFiles(files));
    files.map((thisFile, index) => {
        return dispatch(files_action_start_upload_file(thisFile, true, index === files.length - 1));
    });
};

export const files_action_start_upload_file = (thisFile, multiple, endfile) => dispatch => {
    //validToken();
    if (!!thisFile.startAt || thisFile.startAt instanceof Date) return false;

    const startAt = Date.now();
    const cancelTrigger = getCancelToken();
    const newFile = {...thisFile, startAt, cancelTrigger};

    dispatch(filesUploadingUpdateFile(newFile));

    const config = {onUploadProgress: dispatch(onUploadProgress(newFile)), cancelToken: cancelTrigger.token};
    let data = new FormData();
    data.append('files', newFile.file);

    Api.Files.uploadFile(data, config, newFile /*newFile.file.size*/)
        .then(response => {
            if (multiple) {
                if (endfile) {
                    dispatch(filesUploadedSuccess({
                        ...thisFile,
                        progress: 100,
                        showFileUploadedMessage: true,
                        successUploaded: true
                    }));
                    setTimeout(() => {
                        dispatch(filesUploadedSuccessHideMessage({
                            ...thisFile,
                            progress: 100,
                            showFileUploadedMessage: false,
                            successUploaded: true
                        }));
                    }, 5000);
                }
            } else {
                dispatch(filesUploadedSuccess({
                    ...thisFile,
                    progress: 100,
                    showFileUploadedMessage: true,
                    successUploaded: true
                }));
                setTimeout(() => {
                    dispatch(filesUploadedSuccessHideMessage({
                        ...thisFile,
                        progress: 100,
                        showFileUploadedMessage: false,
                        successUploaded: true
                    }));
                }, 5000);
            }
            dispatch(filesUploadingUpdateFile({...thisFile, progress: 100}));
        })
        .catch(err => {
            if (multiple) {
                if (endfile) {
                    dispatch(filesUploadedSuccess({
                        ...thisFile,
                        progress: 100,
                        showFileUploadedMessage: true,
                        successUploaded: false
                    }));

                    setTimeout(() => {
                        dispatch(filesUploadedSuccess({
                            ...thisFile,
                            progress: 100,
                            showFileUploadedMessage: false,
                            successUploaded: false
                        }));
                    }, 5000);
                }
            } else {
                dispatch(filesUploadedSuccess({
                    ...thisFile,
                    progress: 100,
                    showFileUploadedMessage: true,
                    successUploaded: false
                }));

                setTimeout(() => {
                    dispatch(filesUploadedSuccess({
                        ...thisFile,
                        progress: 100,
                        showFileUploadedMessage: false,
                        successUploaded: false
                    }));
                }, 5000);
            }
            dispatch(filesUploadingUpdateFile({...thisFile, progress: 100, error: {message: err}}));
        });
};

export const files_action_remove_file = thisFile => dispatch => {

    dispatch(filesUploadingRemoveFile(thisFile));
};

export const files_action_retry_file = thisFile => dispatch => {

    const newFile = {...thisFile, progress: 0, estimatedTime: 0, startAt: false, error: false};
    dispatch(filesUploadingUpdateFile(newFile));
    dispatch(files_action_start_upload_file(newFile));
};

const onUploadProgress = thisFile => dispatch => progressEvent => {
    const progress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
    const startAt = thisFile.startAt;
    const timeElapsed = new Date() - startAt;
    const uploadSpeed = progressEvent.loaded / (timeElapsed / 1000);
    const estimatedTime = (progressEvent.total - progressEvent.loaded) / uploadSpeed;

    dispatch(filesUploadingUpdateFile({...thisFile, progress, estimatedTime, startAt}));
};
